module.exports = __webpack_public_path__ + "static/media/AlisonVenning2_JPP.2a77f5c1.jpg";